<template>
  <div id="conexaoCaixaVinculoAtivacao">

    <!-- ============ ainda nao configurado ============ -->
    <div v-if="estado === 'sem_vinculo' || estado === 'revogado'">
      <div class="row q-col-gutter-lg">
        <div class="col-12 col-md-6">
          <q-input
            v-model="cpf"
            label="CPF do responsável"
            mask="###.###.###-##"
            dense
            :disable="carregando"
          />
        </div>
      </div>

      <div class="flex justify-end q-mt-md q-mr-auto">
        <q-btn
          color="primary"
          label="Ativar"
          :loading="carregando"
          :disable="!cpfValido || carregando"
          @click="gerarAtivacao"
        />
      </div>

      <!-- Caminho secundario, discreto de proposito: em evidencia ele anuncia que um
           mesmo computador atende varias empresas. -->
      <div class="q-mt-lg">
        <q-btn
          v-if="!mostrarCodigo"
          flat dense no-caps
          color="grey-7"
          label="Recebi um código"
          @click="mostrarCodigo = true"
        />

        <div v-else class="row q-col-gutter-lg items-end">
          <div class="col-12 col-md-6">
            <q-input
              v-model="codigoCompartilhamento"
              label="Código recebido"
              dense
              autocomplete="off"
              :disable="carregando"
              @keyup.enter="resgatar"
            />
          </div>
          <div class="col-12 col-md-6">
            <q-btn
              color="primary"
              label="Usar código"
              :loading="carregando"
              :disable="!codigoCompartilhamento.trim() || carregando"
              @click="resgatar"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- ============ codigo emitido ============ -->
    <div v-else-if="estado === 'aguardando_agente'">
      <div class="text-body2">
        Informe este código no programa instalado no computador da lotérica.
      </div>

      <div v-if="codigoAtivacao" class="q-mt-md">
        <span class="text-h5 text-weight-bold letra-codigo">{{ codigoAtivacao }}</span>
        <q-btn
          flat dense no-caps
          class="q-ml-sm"
          icon="content_copy"
          color="primary"
          label="Copiar"
          @click="copiarCodigo"
        />
        <div v-if="expiraEm" class="text-caption text-grey-6 q-mt-xs">
          <template v-if="contagemExpirada">Código expirado.</template>
          <template v-else>Válido por mais {{ contagemFormatada }}.</template>
        </div>
      </div>

      <div v-else class="q-mt-md text-grey-7">
        Não foi possível obter o código. Gere um novo.
      </div>

      <div class="q-mt-md">
        <q-btn
          flat dense no-caps
          color="grey-7"
          label="Começar de novo"
          @click="$emit('recomecar')"
        />
      </div>

      <div class="flex justify-end q-mt-md q-mr-auto">
        <!-- "Usar outro computador" = reinstalacao no backend: emite codigo novo
             carregando o agente anterior, reapontando o vinculo para a maquina nova. -->
        <q-btn
          flat no-caps
          class="q-mr-sm"
          color="grey-8"
          label="Usar outro computador"
          :loading="carregando"
          :disable="carregando"
          @click="gerarAtivacao"
        />
        <q-btn
          color="primary"
          label="Baixar programa"
          :disable="!downloadUrl"
          @click="baixarAgente"
        >
          <q-tooltip v-if="!downloadUrl">Link indisponível. Contate o suporte.</q-tooltip>
        </q-btn>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import contagemRegressiva from "@/mixins/contagem-regressiva";

export default {
  name: "ConexaoCaixaVinculoAtivacao",

  emits: ["atualizado", "recomecar"],

  mixins: [contagemRegressiva],

  data() {
    return {
      cpf: "",
      codigoCompartilhamento: "",
      mostrarCodigo: false,
    };
  },

  computed: {
    ...mapGetters([
      "conexaoCaixaVinculoEstado",
      "conexaoCaixaAtivacao",
      "conexaoCaixaVinculoLoading",
    ]),

    estado()        { return this.conexaoCaixaVinculoEstado; },
    carregando()    { return this.conexaoCaixaVinculoLoading; },
    codigoAtivacao(){ return (this.conexaoCaixaAtivacao && this.conexaoCaixaAtivacao.codigo) || null; },
    expiraEm()      { return (this.conexaoCaixaAtivacao && this.conexaoCaixaAtivacao.expira_em) || null; },

    downloadUrl() {
      const daAtivacao = this.conexaoCaixaAtivacao && this.conexaoCaixaAtivacao.download_url;
      const config = this.$store.state.conexao_caixa.conexaoCaixaConfig || {};
      return this.urlDeDownloadSegura(daAtivacao || config.agente_download_url);
    },

    cpfValido() {
      return this.cpf.replace(/\D/g, "").length === 11;
    },
  },

  watch: {
    expiraEm: {
      immediate: true,
      handler(valor) { this.iniciarContagem(valor); },
    },
  },

  mounted() {
    const config = this.$store.state.conexao_caixa.conexaoCaixaConfig || {};
    this.cpf = config.conexao_caixa_cpf || "";
  },

  methods: {
    ...mapActions([
      "gerarCodigoAtivacaoConexaoCaixa",
      "resgatarCompartilhamentoConexaoCaixa",
      "salvarConexaoCaixaConfig",
    ]),

    async gerarAtivacao() {
      const salvo = await this.salvarConexaoCaixaConfig({
        conexao_caixa_ativo: "1",
        conexao_caixa_cpf: this.cpf.replace(/\D/g, ""),
      });
      if (salvo && salvo.error) {
        this.$q.notify({
          message: (salvo.error.message) || "Não foi possível salvar o CPF.",
          color: "red",
          position: "top-right",
        });
        return;
      }

      const res = await this.gerarCodigoAtivacaoConexaoCaixa();
      if (!res.ok) {
        this.$q.notify({ message: res.erro.mensagem, color: "red", position: "top-right" });
        return;
      }
      this.$emit("atualizado");
    },

    async resgatar() {
      const res = await this.resgatarCompartilhamentoConexaoCaixa(this.codigoCompartilhamento);
      if (!res.ok) {
        this.$q.notify({ message: res.erro.mensagem, color: "red", position: "top-right" });
        return;
      }
      this.codigoCompartilhamento = "";
      this.mostrarCodigo = false;
      this.$q.notify({
        message: "Código aceito.",
        color: "green",
        position: "top-right",
      });
      this.$emit("atualizado");
    },

    copiarCodigo() {
      if (!this.codigoAtivacao) return;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.codigoAtivacao).then(
          () => this.$q.notify({ message: "Código copiado.", color: "green", position: "top-right" }),
          () => this.avisarCopiaManual()
        );
        return;
      }
      this.avisarCopiaManual();
    },

    avisarCopiaManual() {
      this.$q.notify({
        message: `Não foi possível copiar. Anote o código: ${this.codigoAtivacao}`,
        color: "orange",
        position: "top-right",
      });
    },

    /**
     * @param {?string} bruto URL do instalador vinda do backend
     * @return {?string} a URL, se e só se for http(s); senão null
     */
    urlDeDownloadSegura(bruto) {
      if (!bruto || typeof bruto !== "string") return null;
      try {
        const url = new URL(bruto, window.location.origin);
        return url.protocol === "https:" || url.protocol === "http:" ? bruto : null;
      } catch (e) {
        return null;
      }
    },

    baixarAgente() {
      if (!this.downloadUrl) return;
      window.open(this.downloadUrl, "_blank", "noopener");
    },
  },
};
</script>

<style scoped>
.letra-codigo {
  letter-spacing: 0.25em;
  font-family: monospace;
}
</style>
